var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-lp-renderer"},[_c('div',{staticClass:"c-lp-renderer__desktop"},[_c('img',{attrs:{"src":_vm.desktop}})]),_c('div',{staticClass:"c-lp-renderer__mobile"},[_c('img',{attrs:{"src":_vm.mobile}})])])}
var staticRenderFns = []

export { render, staticRenderFns }